webpackJsonp([96071698590629],{

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/special-groups-1.9cc45777.jpg";

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/special-groups-2.4abdfff1.jpg";

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/special-groups-3.c8001c04.jpg";

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/special-groups__hero.1ac59160.jpg";

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _specialGroups__hero = __webpack_require__(535);
	
	var _specialGroups__hero2 = _interopRequireDefault(_specialGroups__hero);
	
	var _specialGroups = __webpack_require__(532);
	
	var _specialGroups2 = _interopRequireDefault(_specialGroups);
	
	var _specialGroups3 = __webpack_require__(533);
	
	var _specialGroups4 = _interopRequireDefault(_specialGroups3);
	
	var _specialGroups5 = __webpack_require__(534);
	
	var _specialGroups6 = _interopRequireDefault(_specialGroups5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Group Travel | What We Offer'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _specialGroups__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'Group Travel'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-golden t-context--light' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__images c-golden__short min-laptop' },
	          _react2.default.createElement('img', { src: _specialGroups2.default, alt: '', style: { width: '50%', height: '50%' } }),
	          _react2.default.createElement('img', { src: _specialGroups4.default, alt: '', style: { width: '50%', height: '50%' } }),
	          _react2.default.createElement('img', { src: _specialGroups6.default, alt: '', style: { width: '100%', height: '50%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__content c-golden__wide' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-breadcrumbs mb30' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/what-we-offer' },
	                'What We Offer'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/what-we-offer/special-groups',
	                  activeClassName: 'is-active'
	                },
	                'Group Travel'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-golden__text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-golden__text-col' },
	              _react2.default.createElement(
	                'h1',
	                { className: 't-h1' },
	                'North America\u2019s Group Travel Experts'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p-light mt30' },
	                'With a network of group travel experts strategically based across the continent, ATI is uniquely qualified to plan and coordinate your special event in any North American destination. For groups of 20 to 2,000 or more, ATI will design a custom itinerary, including anything from hotel accommodations to themed events, transportation to top line entertainment. With our team\u2019s expertise and relationships, the possibilities are endless for your group experience in North America. For all Special Group, Event, and Incentive inquires please reach out to us at',
	                ' ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 't-red t-bold',
	                    href: 'mailto:groupslax@americantours.com'
	                  },
	                  'groupslax@americantours.com'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-we-offer-group-travel-js-0b6ed88b9486b83292f2.js